import type { ScreenModule } from "../../../app/screen-module";
import { TenantSettingsPage } from "../pages";

export default {
	id: "tenant-admin.settings",
	path: "/admin/settings",
	area: "tenant-admin",
	navGroup: "管理",
	label: "組織設定",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantSettingsPage,
} satisfies ScreenModule;
